import React, {
    useContext, useCallback, useEffect, useState, useMemo
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from 'gw-portals-validation-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { WizardPage, wizardProps, WizardPageTemplate } from 'gw-portals-wizard-react';
import { fnolCommonMessages } from 'gw-capability-fnol-common-react';
import { messages as commonMessages } from 'gw-platform-translations';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import Address from 'gw-capability-fnol-common-react/models/Address';
import { ViewModelServiceContext, ViewModelForm } from 'gw-portals-viewmodel-react';
import { ModalNextProvider } from '@jutro/components';
import AdjusterContent from 'gw-capability-fnol-common-react/pages/Summary/Component/AdjusterContent';
import AddNotePopup from 'gw-capability-fnol-common-react/pages/Summary/AddNotePopup';
// import { isCapabilityEnabled } from 'gw-portals-config-js';
// import appConfig from 'app-config';
import { useAuthentication } from 'gw-digital-auth-react';
// import { getFontIcon } from '../../../../utils/lobIconUtil';
import VehiclesComponent from '../../../nexus-capability-fnol-ca-react/pages/VehiclesComponent/VehiclesComponent';
import metadata from './CommonDetails.metadata.json5';
import AddressComponent from "../../../gw-capability-common-components/Address/AddressComponent";


function FNOLIncidentCommonDetailsPage(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        }
    } = props;


    const { authHeader } = useAuthentication();

    const { claimStatus } = state;
    const { ClaimDownloadService } = useDependencies('ClaimDownloadService');
    const { ClaimService } = useDependencies('ClaimService');
    const [showLoader, setShowLoader] = useState(false);
    const translator = useContext(TranslatorContext);
    const [fireDamageExists, setFireDamageExists] = useState(false);
    const [waterDamageExists, setWaterDamageExists] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);
    const [selectedLossLocation, setSelectedLossLocation] = useState();
    const OTHER_ID = 'other';
    const newLocationButtonData = { displayName: 'Other Location', id: OTHER_ID };
    const [isLoading, setIsLoading] = useState(false);
    const [popupNotesVM, updatePopupNotesVM] = useState(null);
    const [locationVM, setLocationVM] = useState({});
    const [customAdjusterNote, setCustomAdjusterNote] = useState('');
    const newNoteViewModelObj = (initialData) => {
        return {
            note: viewModelService.create(
                initialData.note,
                'cc',
                'edge.capabilities.note.dto.NoteDTO'
            )
        };
    };


    const {
        onValidate,
        initialValidation,
        isComponentValid,
        registerInitialComponentValidation
    } = useValidation('FNOLIncidentCommonDetailsPage');

    const initialiseVM = useCallback(() => {
        if (claimVM.mainContact.value === null || claimVM.mainContact.value === undefined) {
            _.set(claimVM, 'mainContact', {});
        }
        // since only mobile phone type capturing here
        _.set(claimVM, 'mainContact.primaryPhoneType', 'mobile');

        /*if (_.isEmpty(claimVM.adjusterNoteCM.value)) {
            const getNotesVM = newNoteViewModelObj({
                note: {
                    claimNumber: claimVM.claimNumber.value,
                    subject: 'Additional Info from Insured during online FNOL', // claimVM.adjusterNote.subject.value,
                }
            });
            _.set(claimVM, 'adjusterNoteCM', getNotesVM.note.value);
        }*/

        if (!_.isEmpty(claimVM.adjusterNoteCM.value) && !_.isEmpty(_.get(claimVM, 'adjusterNoteCM.body.value'))) {
            setCustomAdjusterNote(_.get(claimVM, 'adjusterNoteCM.body.value'));
        }
        return claimVM;
    }, [claimVM]);

    const initializeNotesVM = () => {
        if (!_.isEmpty(claimVM.adjusterNoteCM.value)) {
            const getNotesVM = newNoteViewModelObj({
                note: {
                    claimNumber: claimVM.claimNumber.value,
                    subject: 'Additional Info from Insured during online FNOL', // claimVM.adjusterNote.subject.value,
                    body: claimVM.adjusterNoteCM.body.value
                }
            });
            return updatePopupNotesVM(getNotesVM.note);
        }

        const getNotesVM = newNoteViewModelObj({
            note: {
                claimNumber: claimVM.claimNumber.value,
                subject: 'Additional Info from Insured during online FNOL',
                body: ''
            }
        });
        return updatePopupNotesVM(getNotesVM.note);
    };

    useEffect(
        () => {
            const nextclaimVM = initialiseVM();
            let locationId = _.get(claimVM.value, 'lossLocation.publicID');
            if (_.isEmpty(locationId) && !_.isEmpty(_.get(claimVM.value, 'lossLocation'))) {
                locationId = OTHER_ID;
            }
            setSelectedLossLocation(locationId);
            if (!_.isEmpty(_.get(claimVM.value, 'lobs.homeowners.propertyFireDamage'))
                && _.get(claimVM.value, 'lobs.homeowners.propertyFireDamage.isFireDamageExists')) {
                setFireDamageExists(true);
            }

            if (!_.isEmpty(_.get(claimVM.value, 'lobs.homeowners.propertyWaterDamage'))
                && _.get(claimVM.value, 'lobs.homeowners.propertyWaterDamage.isWaterDamageExists')) {
                setWaterDamageExists(true);
            }
            updateWizardData(nextclaimVM);
        },
        // Call once when page gets rendered
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );


    const getPolicyLocations = useMemo(() => {
        const lossLocations = _.get(claimVM.value, 'predefinedLossLocations');
        let formattedLossLocations;
        if (!_.isEmpty(lossLocations)) {
            formattedLossLocations = lossLocations.map((location) => {
                return {
                    displayName: `${location.displayName}`,
                    id: location.publicID,
                    iconName: '',
                    secondaryLabel: ''
                };
            });
        }
        return [...formattedLossLocations, newLocationButtonData];

    }, [claimVM.value]);

    const onLossLocationAddressSelect = useCallback(
        (selectedValue) => {
            if (selectedValue === 'other') {
                const addressViewModel = viewModelService.create(
                    new Address(),
                    'cc',
                    'edge.capabilities.address.dto.AddressDTO'
                );
                _.set(claimVM, 'lossLocation', addressViewModel.value);
            } else {
                const selectedLocations = _.filter(_.get(claimVM.value, 'predefinedLossLocations'), (location) => {
                    return location.publicID === selectedValue;
                });
                _.set(claimVM, 'lossLocation', selectedLocations[0]);
            }
            setSelectedLossLocation(selectedValue);
            updateWizardData(claimVM);
        },
        [claimVM, updateWizardData]
    );

    const showWhenLossCauseNot = useMemo(() => {
        const selectedLossCause = _.get(claimVM.value, 'lossCause');
        return selectedLossCause !== 'datacyber' && selectedLossCause !== 'farmeraccident'
           && selectedLossCause !== 'theftvandalism' && selectedLossCause !== 'wind';
    }, [claimVM.value]);

    const getFileExtension = useCallback((name) => {
        const extension = name.split('.').pop();
        return extension || '';
    }, []);

    const getFileIcon = useCallback((extension) => {
        switch (extension) {
            case 'doc':
            case 'docx':
            case 'txt':
            case 'docm':
                return 'file-word';
            case 'xlt':
            case 'xlsx':
            case 'xlsm':
            case 'xls':
                return 'file-excel';
            case 'gif':
            case 'png':
            case 'jpeg':
                return 'file-image';
            case 'pdf':
                return 'file-pdf';
            default:
                return 'file';
        }
    }, []);

    const changeUploadDocmentImageType = useCallback(
        (documentUploadItem) => {
            const extension = getFileExtension(documentUploadItem.docUID).toLowerCase() || '';
            return `${getFileIcon(extension)}`;
        },
        [getFileExtension, getFileIcon]
    );

    const showDocumentDeleteIcon = useCallback((documentUploadItem) => {
        if (documentUploadItem.canDelete) {
            return true;
        }
        return false;
    }, []);

    const handleError = useCallback(
        (title, message) => {
            return ModalNextProvider.showAlert({
                title: title,
                message: message,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }, []
    );

    const onDeleteDocumentIcon = useCallback(
        (e, item) => {
            e.preventDefault();
            const { claimNumber, publicID, name } = item;
            ModalNextProvider.showConfirm({
                title: fnolCommonMessages.confirmationToRemoveTitle,
                message: translator(fnolCommonMessages.fnolRemoveUploadedDocument, { documentName: name }),
                status: 'warning',
                icon: 'mi-error-outline',
                // confirmButtonText: claimsMessages.removeConfirmationYes,
                confirmButtonText: fnolCommonMessages.removeConfirmationYes,
                cancelButtonText: fnolCommonMessages.removeConfirmationNo
            }).then(async (results) => {
                if (results === 'cancel') {
                    return _.noop();
                }
                setShowLoader(true);
                try {
                    const isDeleteItem = await ClaimService.claimsRemoveDocument(
                        [claimNumber, publicID],
                        authHeader
                    );
                    if (isDeleteItem === false) {
                        setShowLoader(false);
                        return handleError(
                            fnolCommonMessages.deletionFailedTitle,
                            fnolCommonMessages.deletionFailedMessage
                        );
                    }
                    const documentsArray = _.get(claimVM, 'documents.value');
                    const updatedDocArray = documentsArray.filter((documentObj) => {
                        return documentObj.publicID !== publicID;
                    });
                    const newClaimVM = _.clone(claimVM);
                    _.set(newClaimVM, 'documents.value', updatedDocArray);
                    updateWizardData(newClaimVM);
                    setShowLoader(false);
                    return true;
                } catch (documentDeletionError) {
                    setShowLoader(false);
                    return handleError(
                        fnolCommonMessages.removeServiceFailedTitle,
                        fnolCommonMessages.removeServiceFailedMessage
                    );
                }
            }, _.noop);
        },
        [translator, ClaimService, authHeader, claimVM, updateWizardData, handleError]
    );

    const handleDocumentDownload = useCallback(
        (item) => {
            if (_.isNil(item)) {
                return null;
            }
            const { workingPublicID, sessionID } = item;
            return ClaimDownloadService
                .getClaimDocument(workingPublicID, sessionID);
        },
        [ClaimDownloadService]
    );

    const generateMoreInfoDocumentsOverrides = useCallback(() => {
        const documentUploadPath = 'value.documents';
        const documentUploadItems = _.get(claimVM, documentUploadPath, []);
        const overrides = documentUploadItems.map((documentUploadItem, index) => {
            return {
                [`documentLeftSection${index}`]: {
                    icon: changeUploadDocmentImageType(documentUploadItem)
                },
                [`documentNameLink${index}`]: {
                    href: handleDocumentDownload(documentUploadItem)
                },
                [`documentDeleteSection${index}`]: {
                    onClick: (e) => {
                        onDeleteDocumentIcon(e, documentUploadItem);
                    }
                },
                [`documentDeleteIcon${index}`]: {
                    visible: showDocumentDeleteIcon(documentUploadItem)
                }
            };
        });
        return Object.assign({}, ...overrides);
    }, [
        changeUploadDocmentImageType,
        claimVM,
        handleDocumentDownload,
        onDeleteDocumentIcon,
        showDocumentDeleteIcon
    ]);

    const claimsDocUploadToken = useCallback(async () => {
        try {
            const uploadTokenID = await ClaimService.claimsDocUploadToken([], authHeader);
            return uploadTokenID;
        } catch (e) {
            return handleError(
                commonMessages.errorUploadTitle,
                commonMessages.errorGenerateUploadToken
            );
        }
    }, [ClaimService, authHeader, handleError]);

    const onUploadDocument = useCallback(
        async (file) => {
            setShowLoader(true);
            const documentMetaDataTemplate = {
                DocUID: '001',
                DocumentType: 'fnol',
                SecurityType: 'unrestricted',
                Status: 'approved',
                Author: 'Policy Holder',
                claimNumber: claimVM.claimNumber.value,
                name: file.name,
                mimeType: file.type,
                sessionID: await claimsDocUploadToken()
            };
            try {
                const data = await ClaimService.uploadDocument(
                    file,
                    documentMetaDataTemplate,
                    authHeader
                );
                const documentsArray = _.get(claimVM, 'documents.value');
                documentsArray.push(data);
                const newClaimVM = _.clone(claimVM);
                _.set(newClaimVM, 'documents.value', documentsArray);
                updateWizardData(newClaimVM);
                setShowLoader(false);
            } catch (error) {
                setShowLoader(false);
                handleError(commonMessages.errorUploadTitle, commonMessages.uploadFailedMessage);
            }
        },
        [claimVM, claimsDocUploadToken, ClaimService, authHeader, updateWizardData, handleError]
    );

    // Notes


    /* useEffect(() => {
        initializeNotesVM();
        // execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); */

    const showModal = useCallback(
        async (getNotesVM) => {
            const componentProps = {
                title: translator(fnolCommonMessages.additionalInformation),
                actionBtnLabel: fnolCommonMessages.dialogOk,
                cancelBtnLabel: fnolCommonMessages.dialogCancel,
                notesVM: getNotesVM,
                // authHeader: authHeader,
                viewModelService: viewModelService
            };

            const results = await ModalNextProvider.showModal(
                <AddNotePopup {...componentProps} />
            );

            return results;
        },
        [translator, viewModelService, ModalNextProvider]
    );

    const updateNoteData = useCallback(
        (noteVM) => {
            setIsLoading(true);
            const claimNumber = _.get(claimVM.value, 'claimNumber');
            return ClaimService.updateClaimNote(claimNumber, noteVM.value, authHeader)
                .then((response) => {
                    _.set(claimVM, 'adjusterNoteCM.value', response);
                    updateWizardData(claimVM);
                    _.set(noteVM, 'value', response);
                    updatePopupNotesVM(noteVM);
                })
                .catch(() => {
                    ModalNextProvider.showAlert({
                        title: fnolCommonMessages.fnolNoteErrorHead,
                        message: fnolCommonMessages.fnolNoteErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                    return false;
                })
                .finally(() => {
                    setIsLoading(false);
                });
        },
        [claimVM, authHeader, updateWizardData, ClaimService]
    );

    const handleEditNote = useCallback(() => {
        showModal(popupNotesVM).then((updatedVM) => {
            const modifiedVM = viewModelService.clone(updatedVM);
            updateNoteData(modifiedVM);
        }).catch(_.noop);
    }, [popupNotesVM, showModal, updateNoteData, viewModelService]);

    const handleDeleteNote = useCallback(() => {
        setIsLoading(true);
        const claimNumber = _.get(claimVM.value, 'claimNumber');
        const noteId = _.get(claimVM.value, 'adjusterNoteCM.publicID');
        return ClaimService.deleteClaimNote(claimNumber, noteId, authHeader)
            .then((response) => {
                _.set(claimVM, 'adjusterNoteCM.value', response);
                updateWizardData(claimVM);
                // initializeNotesVM();
                initialiseVM();
                // _.set(popupNotesVM, 'value', response);
                // updatePopupNotesVM(popupNotesVM);
            })
            .catch(() => {
                ModalNextProvider.showAlert({
                    title: fnolCommonMessages.fnolNoteErrorHead,
                    message: fnolCommonMessages.fnolNoteErrorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
                return false;
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [claimVM, authHeader, popupNotesVM, updateWizardData, ClaimService]);

    const saveNoteData = useCallback(
        (noteVM) => {
            setIsLoading(true);
            const claimNumber = _.get(claimVM.value, 'claimNumber');
            let parsedContent = noteVM.body.value;
            parsedContent = parsedContent.replace(/'/g, '').replace(/"/g, '');
            noteVM.body = parsedContent;
            return ClaimService.createClaimNote(claimNumber, noteVM.value, authHeader)
                .then((response) => {
                    _.set(claimVM, 'adjusterNoteCM.value', response);
                    updateWizardData(claimVM);
                    _.set(noteVM, 'value', response);
                    updatePopupNotesVM(noteVM);
                })
                .catch(() => {
                    ModalNextProvider.showAlert({
                        title: fnolCommonMessages.fnolNoteErrorHead,
                        message: fnolCommonMessages.fnolNoteErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                    return false;
                })
                .finally(() => {
                    setIsLoading(false);
                });
        },
        [authHeader, claimVM, updateWizardData, ClaimService]
    );

    const addNotesToAdjuster = useCallback(() => {
        showModal(popupNotesVM).then((updatedVM) => {
            const modifiedVM = viewModelService.clone(updatedVM);
            saveNoteData(modifiedVM);
        }).catch(_.noop);
    }, [popupNotesVM, saveNoteData, showModal, viewModelService]);

    const onAddressChange = (value, path) => {
        _.set(claimVM.lossLocation, path, value);
        updateWizardData(claimVM);
       // const newLocationVM = viewModelService.clone(claimVM.lossLocation);
       // setLocationVM(newLocationVM);
    };
    const getDocumentUploadSubHeading = useMemo( () => {
        return (
            <div>
                {translator(fnolCommonMessages.documentUploadSubHeading)} <br/>
                {translator(fnolCommonMessages.supportedFileTypes)} <br/>
                {translator(fnolCommonMessages.maxFileSizeMsg)}
            </div>
        );
    }, [translator]);

    const updateAdjusterNoteData = (value) => {
        setCustomAdjusterNote(value);
    };

    const overrideProps = {
        '@field': {
            showOptional: false
        },
        wasThereFireDamage: {
            value: fireDamageExists,
            visible: showWhenLossCauseNot
        },
        wasThereWaterDamage: {
            value: waterDamageExists,
            visible: showWhenLossCauseNot
        },
        dwellingDesc: {
            visible: _.get(claimVM.value, 'lobs.homeowners.propertyOtherDamage.dwellingIncidents.incident')
        },
        propertyDesc: {
            visible: _.get(claimVM.value, 'lobs.homeowners.propertyOtherDamage.personalPropertyIncident.incident')
        },
        otherStructuresDesc: {
            visible: _.get(claimVM.value, 'lobs.homeowners.propertyOtherDamage.otherStructuresIncident.incident')
        },
        additionalExpensesDesc: {
            visible: _.get(claimVM.value, 'lobs.homeowners.propertyOtherDamage.livingExpensesIncident.incident')
        },
        addressCards: {
            availableValues: getPolicyLocations,
            value:
                selectedLossLocation
                || (!_.isEmpty(claimVM.value) && _.get(claimVM.value, 'lossLocation.publicID')),
            onValueChange: onLossLocationAddressSelect
        },
        addressDiv: {
            visible: selectedLossLocation === OTHER_ID
        },
        addtionalInformationLoader: {
            loaded: !showLoader
        },
        uploadDocumentGrid: {
            visible: !showLoader
        },
        /* addNotebtnDiv: {
            visible: _.isEmpty(claimVM.adjusterNote.value)
        }, */
        adjusterNoteDiv: {
            visible: !_.isEmpty(claimVM.adjusterNoteCM.value)
        },
        /* adjusterContent: {
            handleEditNote,
            handleDeleteNote,
            claimVM
        }, */
        deleteButton: {
            visible: (claimVM.adjusterNoteCM.publicID
                && !_.isEmpty(claimVM.adjusterNoteCM.publicID.value))
        },
        otherAddress: {
            visible: selectedLossLocation === OTHER_ID,
            model: claimVM.lossLocation,
            hideFields: ['addressType'],
            onValueChange: onAddressChange
        },
        documentSubHeader: {
            content: getDocumentUploadSubHeading
        },
        nameHeader: {
            visible: _.isEmpty(claimVM.mainContact.publicID)
                || _.isEmpty(claimVM.mainContact.publicID.value)
        },
        fnolContactFirstName: {
            visible: _.isEmpty(claimVM.mainContact.publicID)
                || _.isEmpty(claimVM.mainContact.publicID.value)
        },
        fnolContactLastName: {
            visible: _.isEmpty(claimVM.mainContact.publicID)
                || _.isEmpty(claimVM.mainContact.publicID.value)
        },
        adjusterNote: {
            value: customAdjusterNote
        },
        vehiclesPage: {
            visible: claimVM.value.policy.policyType === 'BusinessAuto',
            wizardData: claimVM,
            updateWizardData: updateWizardData
        },
        ...generateMoreInfoDocumentsOverrides()

    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(metadata.pageContent, claimVM, id, path, overrideProps);
        },
        [claimVM]
    );

    const validateCustomerNote = () => {
        if (!_.isEmpty(customAdjusterNote)) {
            const getNotesVM = newNoteViewModelObj({
                note: {
                    claimNumber: claimVM.claimNumber.value,
                    body: customAdjusterNote,
                    subject: 'Additional Info from Insured during online FNOL', // claimVM.adjusterNote.subject.value,
                }
            });
            _.set(claimVM, 'adjusterNoteCM', getNotesVM.note.value);
        }
    };

    const resolvers = {
        resolveValue: readValue,
        resolveCallbackMap: {
            // handleFireToggleSelect,
            // handleWaterToggleSelect,
            onUploadDocument: onUploadDocument,
            addNotesToAdjuster: addNotesToAdjuster,
            handleDeleteNote,
            updateAdjusterNoteData
        },
        resolveComponentMap: {
            adjustercontent: AdjusterContent,
            addressComponent: AddressComponent,
            vehiclesPage: VehiclesComponent
        }
    };

    return (
        <WizardPage
            cancelLabel={translator(fnolCommonMessages.fnolSaveandExit)}
            skipWhen={initialValidation}
            template={WizardPageTemplate}
            disableNext={!isComponentValid}
            onNext={validateCustomerNote()}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                resolveValue={resolvers.resolveValue}
            />
        </WizardPage>
    );
}

FNOLIncidentCommonDetailsPage.propTypes = wizardProps;
export default withRouter(FNOLIncidentCommonDetailsPage);
